<template>
  <!-- jedan blok oglasa za sve slucajeve: sta se prikazuje odredjuju propovi
       (TopAds, TopAdsNew, TopAdsOther i TopAdsPages su samo tanki omotaci oko ovoga) -->
  <BlockCard
    :title="title"
    :title-to="headingLink"
    :dropdown-items="dropdown ? dropdownItems : []"
    :dropdown-label="dropdownLabel"
  >
    <AdRow
      v-for="item in visibleItems"
      :key="item.id"
      :advertisement="item"
      :show-image="showImage"
    />
  </BlockCard>
</template>

<script setup>
import BlockCard from '~/components/widgets/BlockCard.vue'
import AdRow from '~/components/cmsCustomer/advertisement/display/AdRow.vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  // oglas ulazi u blok kad se sva polja iz filtera poklapaju (npr. { top_ad: 1, top_category: 0, lawyer: 0 }), vidi composables/useItemFilter.ts
  filter: { type: Object, default: () => ({}) },
  // najvise oglasa u bloku; 0 = svi
  limit: { type: Number, default: 0 },
  title: { type: String, default: '' },
  // kuda vodi naslov (objekat rute); podrazumevano lista svih oglasa
  titleTo: { type: Object, default: null },
  showImage: { type: Boolean, default: true },
  // padajuca lista u gornjem uglu: 'category' | 'subcategory' | '' (bez liste)
  dropdown: { type: String, default: 'category' },
  dropdownLabel: { type: String, default: 'Kategorije' },
})

const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()
const { uniqValuesByKey, uniqByKeys } = useCollectionUtils()

const filtered = computed(() => filterByFields(props.items, props.filter))

const visibleItems = computed(() => (props.limit > 0 ? filtered.value.slice(0, props.limit) : filtered.value))

const headingLink = computed(() =>
  routePath(props.titleTo || { name: 'oglasi-svi-oglasi-page', params: { page: 1 } })
)

const dropdownItems = computed(() => {
  if (props.dropdown === 'category') {
    return uniqValuesByKey(filtered.value, 'category_name').map((name) => ({
      key: name,
      label: name,
      to: { name: 'oglasi-category-page', params: { category: $srbTolat.srbTolat(name), page: 1 } },
    }))
  }

  if (props.dropdown === 'subcategory') {
    return uniqByKeys(filtered.value, ['category_name', 'subcategory_name']).map((item) => ({
      key: `${item.category_name}|${item.subcategory_name}`,
      label: item.subcategory_name,
      to: {
        name: 'oglasi-category-subcategory-page',
        params: {
          category: $srbTolat.srbTolat(item.category_name),
          subcategory: $srbTolat.srbTolat(item.subcategory_name),
          page: 1,
        },
      },
    }))
  }

  return []
})
</script>
